var COMPONENTNAME = (function( $ ) {

	var _init = function() {
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = COMPONENTNAME;